import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { util } from '../../../util'

const Typography = ({
    background,
    className,
    color,
    display,
    fontType = 'regular',
    size = 'rg',
    text,
    isItalic,
    isUnderline = false,
    variant: Type = 'p',
    hover,
    show = true,
    align,
    shouldBreakWord,
    textTransform,
    ...rest
}) => {
    if (!show) {
        return null
    }
    const getClass = util.joinClasses(
        'typography',
        shouldBreakWord && 'break-word',
        background && `background-${background}`,
        isItalic && 'font-italic',
        color && `color-${color}`,
        display,
        fontType,
        size,
        hover,
        isUnderline && 'underline',
        className,
        textTransform && `text-${textTransform}`,
        align
    )
    return (
        <Type data-testid={'typography'} className={getClass} {...rest}>
            {text}
        </Type>
    )
}

Typography.propTypes = {
    background: PropTypes.oneOf(['light', 'dark', 'primary', 'default']),
    className: PropTypes.string,
    color: PropTypes.oneOf([
        'light',
        'dark',
        'primary',
        'danger',
        'warning',
        'gray',
        'info',
        'success',
    ]),
    display: PropTypes.oneOf(['inline', 'block', 'inline-block']),
    fontType: PropTypes.oneOf([
        'regular',
        'medium',
        'bold',
        'light',
        'trasandina',
        'trasandina-bold',
        'font-light-italic',
    ]),
    hover: PropTypes.oneOf(['pointer']),
    type: PropTypes.oneOf(['italic']),

    /* 'xs' 3rem, 'sm' 3.5rem, 'rg' 4rem, 'md' 4.5rem, 'lg' 6rem, 'xl' 8rem, 'xxl' 10rem */
    size: PropTypes.oneOf(['xs', 'sm', 'rg', 'md', 'lg', 'xl', 'xxl']),

    text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'p']),
    isUnderline: PropTypes.bool,
    align: PropTypes.oneOf(['right', 'center', 'left']),
    textTransform: PropTypes.oneOf(['capitalize', 'uppercase', 'lowercase']),
}

export default memo(Typography)
